import { GET_VISION_DATA, GET_VISION_ITEM_DATA } from "./actionType";

const defaultState = {
  visionData: {},//展示数据
  visionInfo: {
    info: {
      left_eye: 0,//左眼
      right_eye: 0,//右眼
      left_eye_type: 0,//左 1.正常 2.近视 3.远视 4.散光
      right_eye_type: 0,//右
      presby_status: 0,//老花
      colour_blind_status: 0,//色盲
    },
    trend: []
  }
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_VISION_DATA://存
      const newVisionData = { ...state };
      newVisionData.visionData = action.visionData;
      return newVisionData;
    case GET_VISION_ITEM_DATA://修改
      const newVisionItemData = { ...state };
      newVisionItemData.visionInfo.info = action.visionInfo.info ?
        { ...newVisionItemData.visionInfo.info, ...action.visionInfo.info } :
        newVisionItemData.visionInfo.info;
      newVisionItemData.visionInfo.trend = action.visionInfo.trend ?
        [...action.visionInfo.trend] :
        newVisionItemData.visionInfo.trend;
      return newVisionItemData;
    default:
      return state;
  }
};

export default Reducer;
